import React, { useEffect } from 'react'
import Hero from '../component/Hero'
import IntroSection from '../component/IntroSection'
import Prestation from '../component/prestations'
import Creation from '../component/creation'
import Partenaire from '../component/partenaire'

/* Page d'accueil */
function Home() {
  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = 'Place des Victoires — Studio de création multimédia inclusif'
  }, [])

  return (
    <div className="w-full">
      <Hero />
      <IntroSection />
      <Prestation />
      <Partenaire />
      <Creation />
    </div>
  )
}

export default Home
